export default __webpack_public_path__ + "static/media/globe.328fd5a3.svg";